module.exports = __webpack_public_path__ + "img/sec1.028ca6eb.png";